// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    PasswordIcon,
    QuestionIcon,
    ShoppingCartIcon,
    TestIcon,
    TagIcon,
    UsersIcon,
    GroupIcon,
    BadgeIcon,
    NotificationIcon,
    ReportIcon
} from 'utils/Icons';

// constant
const icons = {
    PasswordIcon,
    UsersIcon,
    QuestionIcon,
    TestIcon,
    ShoppingCartIcon,
    TagIcon,
    GroupIcon,
    BadgeIcon,
    NotificationIcon,
    ReportIcon
};

const systemManagement = {
    id: 'system-management',
    type: 'group',
    title: <FormattedMessage id="system-management" />,
    children: [
        {
            id: 'questions',
            permission: 'User',
            title: <FormattedMessage id="questions" />,
            type: 'collapse',
            icon: icons.QuestionIcon,
            breadcrumbs: false,
            children: [
                {
                    id: 'single-question-list',
                    permission: 'User',
                    title: <FormattedMessage id="single-question" />,
                    type: 'item',
                    url: '/single-question'
                },
                {
                    id: 'collection-list',
                    permission: 'User',
                    title: <FormattedMessage id="collection-list" />,
                    type: 'item',
                    url: '/collection'
                }
            ]
        },
        {
            id: 'user-management',
            title: <FormattedMessage id="user-management" />,
            type: 'collapse',
            icon: icons.PasswordIcon,
            breadcrumbs: false,
            children: [
                {
                    id: 'user-list',
                    permission: 'User',
                    title: <FormattedMessage id="user-list" />,
                    type: 'item',
                    url: '/user-list'
                },
                {
                    id: 'user-groups',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="user-groups" />,
                    type: 'item',
                    url: '/user-groups'
                }
            ]
        },
        {
            id: 'tag-management',
            permission: 'User',
            title: <FormattedMessage id="tag-management" />,
            type: 'item',
            url: '/tag-management',
            icon: icons.TagIcon,
            breadcrumbs: true
        },
        {
            id: 'work-groups',
            permission: 'User',
            title: <FormattedMessage id="work-groups" />,
            type: 'collapse',
            icon: icons.UsersIcon,
            breadcrumbs: false,
            children: [
                {
                    id: 'manage-channels-and-messages',
                    permission: 'User',
                    title: <FormattedMessage id="manage-channels-and-messages" />,
                    type: 'item',
                    url: '/work-group-channels-and-messages'
                },
                {
                    id: 'work-groups-management',
                    permission: 'User',
                    title: <FormattedMessage id="work-groups-management" />,
                    type: 'item',
                    url: '/work-groups-management'
                },
                {
                    id: 'group-record-management',
                    permission: 'User',
                    title: <FormattedMessage id="group-record-management" />,
                    type: 'item',
                    url: '/work-group-record-management'
                }
            ]
        },
        {
            id: 'products',
            title: <FormattedMessage id="products" />,
            type: 'collapse',
            icon: icons.ShoppingCartIcon,
            breadcrumbs: true,
            children: [
                {
                    id: 'product-categories',
                    permission: 'User',
                    title: <FormattedMessage id="product-categories" />,
                    type: 'item',
                    url: '/product-categories'
                },
                {
                    id: 'products',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="products" />,
                    type: 'item',
                    url: '/products'
                },
                {
                    id: 'specs',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="specs" />,
                    type: 'item',
                    url: '/specs'
                },
                {
                    id: 'classes',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="classes" />,
                    type: 'item',
                    url: '/classes'
                }
            ]
        },
        {
            id: 'assignments',
            title: <FormattedMessage id="assignments" />,
            type: 'collapse',
            icon: icons.TestIcon,
            breadcrumbs: true,
            children: [
                {
                    id: 'assignments',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="assignments" />,
                    type: 'item',
                    url: '/assignments'
                },
                {
                    id: 'containers',
                    permission: 'User',
                    title: <FormattedMessage id="containers" />,
                    type: 'item',
                    url: '/containers'
                },
                {
                    id: 'atomic-units',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="atomic-units" />,
                    type: 'item',
                    url: '/atomic-units'
                }
            ]
        },
        {
            id: 'connection-sources',
            permission: 'User',
            title: <FormattedMessage id="connection-sources-layout" />,
            type: 'collapse',
            icon: icons.GroupIcon,

            breadcrumbs: true,
            children: [
                {
                    id: 'connection',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="connection" />,
                    type: 'item',
                    url: '/connection'
                },
                {
                    id: 'connectiontoproduct',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="connectiontoproduct" />,
                    type: 'item',
                    url: '/connectiontoproduct'
                },
                {
                    id: 'notemangement',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="notemangement" />,
                    type: 'item',
                    url: '/notemanagement'
                },
                {
                    id: 'essay',
                    permission: 'UserGroup',
                    title: <FormattedMessage id="essay" />,
                    type: 'item',
                    url: '/essay'
                }
            ]
        },
        {
            id: 'icon-library',
            permission: 'User',
            title: <FormattedMessage id="icon-library" />,
            type: 'item',
            url: '/icon-management',
            icon: icons.BadgeIcon,
            breadcrumbs: true
        },
        {
            id: 'messages',
            permission: 'User',
            title: <FormattedMessage id="messages" />,
            type: 'item',
            url: '/messages',
            icon: icons.NotificationIcon,
            breadcrumbs: true
        }
        // {
        //     id: 'system-reports',
        //     permission: 'SystemReport',
        //     title: <FormattedMessage id="system-reports" />,
        //     type: 'item',
        //     url: '/system-reports',
        //     icon: icons.ReportIcon,
        //     breadcrumbs: false
        // }
    ]
};

export default systemManagement;
